<template>
  <div
    @click="openTile"
    class=""
    :class="{'is-opened': isOpen, 'stat-ligne' : isTotal, 'is-radius-large' : !isTotal}">
    <div class="columns is-gapless">
      <div v-if="!isTotal" class="is-radius-top-left-large is-radius-top-right-large"
            :class="{ 'over' : children.length }"></div>
      <div class="columns column is-3 is-vcentered">
        <div class="column is-8 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          <strong>{{origin.name}}</strong><br>
          <span class="is-size-7" v-if="children && children.length > 0">
            <span v-for="child in children">{{child.name}} </span>
          </span>
        </div>
        <div class="column is-4 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          {{totalRow.contacts}}
        </div>
      </div>
      <div class="columns column is-6 is-vcentered">
        <div class="column is-2 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          {{totalRow.rdvs}}
        </div>
        <div class="column is-2 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          <span v-if="contactCost">{{contactCost| prettyPrice}}</span>
          <span v-else>--</span>
        </div>
        <div class="column is-2 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          <span v-if="rdvCost">{{rdvCost| prettyPrice}}</span>
          <span v-else>--</span>
        </div>
        <div class="column is-2 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          <span v-if="currentCost">{{currentCost.cost | prettyPrice}} {{$currency}}</span>
          <span v-else>--</span>
        </div>
        <div class="column is-2 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          {{totalRow.advs}}<br>
        </div>
        <div class="column is-2 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          <span v-if="currentCost">{{currentCost.margin | prettyPrice}} {{$currency}}</span>
          <span v-else>--</span><br>
        </div>
      </div>
      <div class="columns column is-3 is-border-left is-lighten-2 is-vcentered" :class="{'has-bg-light': !isTotal, 'has-bg-primary': isTotal}">
        <div class="column is-4 is-paddingless-right is-padding-top-small is-padding-bottom-small is-padding-left-small">
          <span v-if="saleRatio">{{saleRatio | prettyPrice}} {{$currency}}</span>
          <span v-else>--</span><br>
        </div>
        <div class="column is-5 is-paddingless-right is-padding-left-small is-padding-top-small is-padding-bottom-small">
          <span v-if="margin">{{margin | prettyPrice}} {{$currency}}</span>
          <span v-else>--</span><br>
        </div>
        <div class="column has-text-centered actions is-3 is-paddingless-right is-paddingless-left is-padding-top-small is-padding-bottom-small">
          <!--<button v-if="!isTotal && canBeRemove && isOpen" class="button is-circle is-small">
            <i class="fal fa-bars"></i>
          </button>
          <button v-if="!isTotal && canBeRemove && !isOpen" class="button is-circle is-small">
            <i class="fal fa-minus"></i>
          </button> -->
          <router-link :to="{name:'OriginVue', params: {id: origin.pk}}" v-if="!isTotal" class="button is-circle is-small">
            <i class="fal fa-pen"></i>
          </router-link>
        </div>
      </div>
    </div>

    <div class="stat-detail is-size-6 is-border-top is-border-dashed is-padding-top-small" v-if="isOpen">
      <child-row v-for="child in children" :key="child.pk" :origin="child" :date="date"></child-row>
    </div>
  </div>
</template>

<script>
  import { OriginRowMx } from '../../../mixins'
  import ChildRow from './ChildRow'

  export default {
    name: 'OriginRow',
    mixins: [OriginRowMx],
    components: {
      ChildRow
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      isTotal: {
        type: Boolean,
        default: false
      },
      canBeRemove: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {}
    },
    computed: {
      row () {
        return this.totalRow
      },
      rdvs () {
        return this.totalRow.rdvs
      },
      contacts () {
        return this.totalRow.contacts
      },
      advs () {
        return this.totalRow.advs
      },
      totalRow () {
        if (this.children && this.children.length > 0) {
          return this.children.reduce((accum, val) => {
            return {
              contacts: accum.contacts + val.contacts.length,
              rdvs: accum.rdvs + val.rdvs.length,
              advs: accum.advs + val.advs.length
            }
          }, {
            contacts: 0,
            rdvs: 0,
            advs: 0
          })
        } else {
          return this.origin
        }
      },
      children () {
        return this.origin.children
      }
    },
    methods: {
      openTile () {
        if (!this.children || !this.children.length) return
        this.$emit('open', this.origin)
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/statistics/multidiffusion/OriginRow.vue